import { useEffect, useState } from 'react'

import Api from 'services/api'
import { PaywallAcct } from 'types/PaywallAcct'
import { PaywallPlanChange } from 'types/PaywallPlanChange'

const useActiveHehmAccount = (dealerId) => {
  const [activeHehmAccount, setActiveHehmAccount] = useState<PaywallAcct>()
  const [isActiveHehmAccountLoaded, setIsActiveHehmAccountLoaded] = useState(false)
  const [hehmPlanChange, setHehmPlanChange] = useState<PaywallPlanChange>()
  const [isHehmPlanChangeLoaded, setHehmPlanChangeLoaded] = useState(false)
  const [hehmQuantity, setHehmQuantity] = useState()
  const [isHehmQuantityLoaded, setIsHehmQuantityLoaded] = useState(false)

  useEffect(() => {
    if (dealerId) {
      Api.Paywall.getActiveAcct(dealerId, 'hehm')
        .then(res => {
          setActiveHehmAccount(res)
        })
        .catch(() => {})
        .finally(() => setIsActiveHehmAccountLoaded(true))

      Api.Paywall.getAcctPlanChange(dealerId, 'hehm')
        .then(res => {
          setHehmPlanChange(res)
        })
        .catch(() => {})
        .finally(() => setHehmPlanChangeLoaded(true))

      Api.Paywall.getHehmQuantity(dealerId)
        .then(res => {
          setHehmQuantity(res.quantity)
        })
        .catch(() => {})
        .finally(() => setIsHehmQuantityLoaded(true))
    }
  }, [dealerId])

  return { activeHehmAccount, isActiveHehmAccountLoaded, hehmPlanChange, isHehmPlanChangeLoaded, hehmQuantity, isHehmQuantityLoaded }
}

export default useActiveHehmAccount
